import { nextApi } from "@/utils/api"

import { HttpMethod, wrapperApiRequest } from "@/apis/baseRequest"
import { BlockchainNetwork } from "@renec-foundation/relend-adapter"

// Generic API request function
const makeApiRequest = wrapperApiRequest(nextApi)
const fetchPools = (
  params: {
    refresh?: boolean
    network?: BlockchainNetwork
  } = {},
) => makeApiRequest(HttpMethod.GET, "/pools", {}, params)

export const NextAPIRequests = {
  fetchPools,
}
